export default "__VITE_ASSET__ad06ac3e__"